import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { DiscountListFilters } from "@modules/discounts/components/DiscountListFilters";

import { useDiscountsList } from "./controller";
import { useDiscountsListColumns } from "./columns";

export const DiscountList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    companies,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } = useDiscountsList();

  const columns = useDiscountsListColumns(refetch, translate, companies);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              for_agreement: "",
            }}
          >
            <DiscountListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
